// Regex to remove trailing zeroes (and optional '.').
var trimRegex = /\.?0+$/;
var oneKiloByte = 1024;
var oneMegaByte = 1048576;
var oneGigaByte = 1073741824;
var oneTeraByte = 1099511627776;
/**
 * Creates a display string by converting bytes to closest storage unit
 * This function produces a string value meant to mimic the string displayed by file explorer/One Drive
 * Code reference: https://onedrive.visualstudio.com/ODSP-Web/_git/odsp-web?path=/odsp-common/items-view/utilities/src/string/DriveSpaceHelper.ts&version=GBmain&_a=contents
 */
export function getStorageSizeString(storageSizeResourcesMap, value, options) {
    if (options === void 0) { options = {}; }
    if (typeof value !== 'number' ||
        isNaN(value) ||
        (options.ignoreZero && value === 0) ||
        value < 0) {
        return '';
    }
    var trimDecimal = options.trimDecimal || false;
    // 1 byte
    if (value === 1) {
        return storageSizeResourcesMap.get('fileSizeBytesSingular') || '';
    }
    // 0 bytes, 2 bytes - 1023 bytes
    if (value < oneKiloByte) {
        return storageStringFormat(storageSizeResourcesMap.get('fileSizeBytesPlural') || '', value, trimDecimal);
    }
    // 1KB - 999 KB
    if (value < 1000 * oneKiloByte) {
        return storageStringFormat(storageSizeResourcesMap.get('fileSizeKB') || '', value / oneKiloByte, trimDecimal);
    }
    // 0.97 MB - 999 MB
    if (value < 1000 * oneMegaByte) {
        return storageStringFormat(storageSizeResourcesMap.get('fileSizeMB') || '', value / oneMegaByte, trimDecimal);
    }
    // 0.97 GB - 999 GB
    if (value < 1000 * oneGigaByte) {
        return storageStringFormat(storageSizeResourcesMap.get('fileSizeGB') || '', value / oneGigaByte, trimDecimal);
    }
    // 0.97 TB ->
    return storageStringFormat(storageSizeResourcesMap.get('fileSizeTB') || '', value / oneTeraByte, trimDecimal);
}
function storageStringFormat(template, value, trimDecimal) {
    return template.replace('{0}', _trimNumber(value, trimDecimal));
}
// Locale.numberRadix = (1.2).toLocaleString(Locale.language).replace(/\d+/g, '');
function _trimNumber(value, trimDecimal) {
    // 12.00 -> 12
    if (value >= 100 || value === Math.floor(value)) {
        return value.toFixed(0);
    }
    // 45.678 -> 45.7
    var str = value.toFixed(1);
    // TODO: Do we have capability to find locale radix?
    // Since Number(num.toFixed) can trim decimals even when unwanted,
    // get the radix character and replace it manually
    // return (trimDecimal ? str.replace(trimRegex, '') : str).replace(
    //     '.',
    //     Locale.numberRadix,
    // );
    return trimDecimal ? str.replace(trimRegex, '') : str;
}
//# sourceMappingURL=getStorageSizeString.js.map